import React, { Component } from 'react'
import Section from '../shared/Section'
import Header from '../shared/Section/Header'
import topImage from './reliable-top.png'
import bottomImage from './reliable-bottom.png'
import { extendBaseClass, getClassWithVariant } from '../../utils/classes'
import ToggleVideo from './ToggleVideo'
import Modal from '../shared/Modal'

export class Video extends Component {
  state = {
    showVideo: false,
  }

  baseClass = 'video'

  extend = extendBaseClass.bind(this)

  getImageClass = (variant) => {
    const imageClass = this.extend('image')
    return getClassWithVariant(variant, imageClass)
  }

  setShowVideo = (showVideo) => this.setState({ showVideo })

  render() {
    const { showVideo } = this.state
    return (
      <Section extraClasses="video">
        <img src={topImage} alt="#" className={this.getImageClass('top')} />
        <Header
          title="See how Mosto can help"
          headline="Easy and safe Reliable messaging"
          description="Organizes all your conversations, productivity tools, and apps in one place. Because it’s not just the message, it’s how you work together that matters."
          parentClass={this.baseClass}
        />
        <Modal
          setShowVideo={this.setShowVideo}
          showVideo={showVideo}
          parentClass={this.baseClass}
        />
        <ToggleVideo
          parentClass={this.baseClass}
          setShowVideo={this.setShowVideo}
        />
        <img
          src={bottomImage}
          alt="#"
          className={this.getImageClass('bottom')}
        />
      </Section>
    )
  }
}

export default Video
